export enum Months {
	JANUARY = 'January',
	FEBRUARY = 'February',
	MARCH = 'March',
	APRIL = 'April',
	MAY = 'May',
	JUNE = 'June',
	JULY = 'July',
	AUGUST = 'August',
	SEPTEMBER = 'September',
	OCTOBER = 'October',
	NOVEMBER = 'November',
	DECEMBER = 'December'
}

export enum MonthsAbbreviated {
	JANUARY = 'Jan',
	FEBRUARY = 'Feb',
	MARCH = 'Mar',
	APRIL = 'Apr',
	MAY = 'May',
	JUNE = 'Jun',
	JULY = 'Jul',
	AUGUST = 'Aug',
	SEPTEMBER = 'Sep',
	OCTOBER = 'Oct',
	NOVEMBER = 'Nov',
	DECEMBER = 'Dec'
}
